import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Title = styled.div`
  font-family: "BroadwayD";
  font-size: 1.5rem;
  margin-bottom: 12px;
  background: linear-gradient(135deg, #f990e8, #0bd2d3);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
`;

export const GradientText = styled.span`
  background: linear-gradient(135deg, #0bd2d3, #f990e8);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  font-family: "BroadwayD";
`;

export const Text = styled.div`
  color: #999;
  font-size: 15px;
  line-height: 1.7;
  margin-bottom: 16px;
`;
